import { render } from "./App.vue?vue&type=template&id=3aa08916&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3aa08916&lang=scss"

import exportComponent from "/Users/jdmacminim61/Workspace/golfourit_ec_system/ec-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__